import React, {PureComponent} from 'react';
import {configStore} from 'app/store/global';
import PopupVideoBgDefaultWebm from 'videos/lootbox/video-default.webm';
import PopupVideoBgCSGOWebm from 'videos/lootbox/video-csgo.webm';
import PopupVideoBgDota2Webm from 'videos/lootbox/video-dota.webm';
import PopupVideoBgDefaultMp4 from 'videos/lootbox/video-default.mp4';
import PopupVideoBgCSGOMp4 from 'videos/lootbox/video-csgo.mp4';
import PopupVideoBgDota2Mp4 from 'videos/lootbox/video-dota.mp4';
import PopupVideoBgDefaultOgv from 'videos/lootbox/video-default.ogv';
import PopupVideoBgCSGOOgv from 'videos/lootbox/video-csgo.ogv';
import PopupVideoBgDota2Ogv from 'videos/lootbox/video-dota.ogv';

interface PrizeBackgroundProps {
    steam_skin?: {
        game_id?: number;
    }
}

export default class PrizeBackground extends PureComponent<PrizeBackgroundProps> {
    get videoBackground(): {
        mp4: string;
        ogv: string;
        webm: string;
        } {
        const {steam_skin} = this.props;

        switch (true) {
        case steam_skin && steam_skin.game_id === configStore.FILTER_GAME_CS:
            return {
                mp4: PopupVideoBgCSGOMp4,
                ogv: PopupVideoBgCSGOOgv,
                webm: PopupVideoBgCSGOWebm
            };
        case steam_skin && steam_skin.game_id === configStore.FILTER_GAME_DOTA:
            return {
                mp4: PopupVideoBgDota2Mp4,
                ogv: PopupVideoBgDota2Ogv,
                webm: PopupVideoBgDota2Webm
            };
        default:
            return {
                mp4: PopupVideoBgDefaultMp4,
                ogv: PopupVideoBgDefaultOgv,
                webm: PopupVideoBgDefaultWebm
            };
        }
    }

    render(): React.ReactNode {
        return <video
            className="prize-won-background-video"
            autoPlay
            playsInline
            loop>
            <source
                src={this.videoBackground.webm}
                type='video/webm; codecs="vp8, vorbis"'
            />
            <source
                src={this.videoBackground.mp4}
                type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
            />
            <source
                src={this.videoBackground.ogv}
                type='video/ogg; codecs="theora, vorbis"'
            />
        </video>;
    }
}
